import { useQuery } from '@tanstack/react-query';
import { posRestaurant } from '../../../api/posAPI';
import usePosStore from '../../../stores/posStore';

export function useProducts() {
  const { posToken } = usePosStore();

  const query = useQuery({
    queryKey: ['pos', 'products', posToken],
    queryFn: async () => {
      const res = await posRestaurant.products(posToken);
      // groupedProducts: [{ category, items }]
      return {
        groupedProducts: res.data.groupedProducts || [],
        flat: res.data.products || [],
      };
    },
    enabled: !!posToken,
    staleTime: 5 * 60_000,
  });

  return {
    groupedProducts: query.data?.groupedProducts || [],
    products: query.data?.flat || [],
    isLoading: query.isLoading,
    error: query.error?.response?.data?.message || query.error?.message || null,
    refetch: query.refetch,
  };
}
